import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const i18nMessages = defineMessages({
  noFilteredSuperProfiles: {
    id: 'account.super-profiles.no-filtered-super-profiles',
    defaultMessage: 'No SuperProfiles found',
  },
});

const NoFilteredSuperProfiles = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <br />
      <div className="align-center font-weight-600">{formatMessage(i18nMessages.noFilteredSuperProfiles)}</div>
    </>
  );
};

export default NoFilteredSuperProfiles;
